export default [
  { to: 'allmant', title: 'Allmänt' },
  { to: 'behandlingsriktlinjer', title: 'Behandlingsriktlinjer' },
  { to: 'calculator', title: 'Dosberäkning' },
  { to: 'akm_uso', title: 'Akm USÖ' },
  { to: 'ambulans_intern', title: 'Ambulans intern' },
  { to: 'arkiv', title: 'Arkiv' },
];
